import styled from "styled-components";

export const Container = styled.div `

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;

    header {
        margin-bottom: 50px;
        width: 100%;
    }

    header h4 {
        font-size: .9rem;
        font-weight: 600;
        margin-top: -10px;
        color: #ccc;
    }

    form section {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .section-user-delete {
        position: relative;
    }

    .section-image-color {
        position: absolute;
        bottom: -5px;
        left: -5px;
        margin-bottom: 0;
    }

    .section-image-color button {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: #fff;
        font-size: 1rem;
        margin-right: 10px;
        background: #fff;
        color: #181818;
        border: none;
        cursor: pointer;
        transition: all .3s ease;
    }

    .section-image-color button:hover {
        background: #ccc;
    }
    
    form img {
        width: 120px;
        border-radius: 5px;
        margin-right: 10px;
    }

    .div-input-delete-profile {
        display: flex;
        flex-direction: column;
    }
    
    .div-input-delete-profile .profile_name {
        font-size: 1.2rem;
        font-weight: 600;
    }
    
    .div-input-delete-profile .profile_email {
        font-size: .8rem;
        font-weight: 600;
        margin-bottom: 10px;
    }

    form input {
        height: 50px;
        border-radius: 5px;
        color: #fff;
        padding: 5px;
        background: #505050;
        width: 100vw;
        max-width: 250px;
        border: 1px solid #808080;
    }

    form input::placeholder {
        color: #ccc;
    }

    .section-bts-delete-profile button {
        margin-right: 10px;
        border-radius: 5px;
        padding: 10px 25px;
        font-size: 1rem;
        border: none;
        background: #f00;
        color: #fff;
        font-weight: 600;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all .3s ease;
    }

    .section-bts-delete-profile button:hover {
        opacity: .7;
    }

    .section-bts-delete-profile button:last-child {
        background: unset;
        color: #fff;
        border: 2px solid #ccc;
        margin-right: 0;
    }

    .div-message-erro {
        margin: 5px 0 15px 0;
    }

    .descricao-erro {
        font-size: .85rem;
        font-weight: 600;
        text-align: center;
    }

    @media (max-width: 450px) {
        .section-profile-delete {
            display: flex;
            flex-direction: column;
        }

        .div-input-delete-profile {
            align-items: center;
            margin-top: 10px;
        }

        header {
            text-align: center;
        }

        header h4 {
            font-size: .75rem;
        }

        form input {
            height: 50px;
            border-radius: 5px;
            color: #fff;
            padding: 5px;
            background: #505050;
            width: 100vw;
            max-width: 200px;
            border: 1px solid #808080;
        }

        .section-bts-delete-profile {
            flex-direction: column;
        }

        .section-bts-delete-profile button {
            display: flex;
            justify-content: center;
            margin: 0 0 5px 0;
            border-radius: 5px;
            padding: 10px 25px;
            width: 100%;
            font-size: 1rem;
        }
    }

`
